import MovimentacaoForm, { IMovimentacaoFormProps } from "./MovimentacaoForm";

interface IMovimentacaoFormScreenProps extends IMovimentacaoFormProps {

}
export default function MovimentacaoFormScreen (props:IMovimentacaoFormScreenProps) {
    return <MovimentacaoForm {...props} />
}